export default {
  pagination: {},
  plan: {},
  plans: []
};
